var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.042 11.628v8.374H3.196v-8.374H0V8.233h3.196V6.998C3.196 2.41 5.11 0 9.166 0c1.242 0 1.552.2 2.233.362v3.359c-.762-.133-.976-.207-1.768-.207-.94 0-1.442.266-1.901.791-.459.525-.688 1.435-.688 2.737V8.24H11.4l-1.169 3.396H7.042v-.008Z",
    fill: "#E8E1F9"
  })));
};
export default SvgFacebook;